import { createFileRoute, redirect } from '@tanstack/react-router';
import { orgLandingPath, type OrgLandingPath } from '@siliconx/shared';
import { fetchClientIdentity } from '../lib/auth';

/**
 * SIL-2534: org-type landing. A reseller lands on the margin workbench; every
 * other org type (and any identity failure or null org type) lands on
 * /dashboard exactly as before. The mapping lives in shared `orgLandingPath`
 * (table + `hasOrgFeature('marketIntel')`), never an org-type compare here.
 */
export async function resolveLanding(): Promise<OrgLandingPath> {
  try {
    return orgLandingPath((await fetchClientIdentity()).organizationType);
  } catch {
    return '/dashboard';
  }
}

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    throw redirect({ to: await resolveLanding() });
  },
});
